import React from 'react'
import PropTypes from 'prop-types'
import TimeUtil from 'utils/time-util'
import { Badge } from 'reactstrap'
import StringUtil from 'utils/string-util'

const propTypes = {
  time       : PropTypes.string,
  title      : PropTypes.string,
  color      : PropTypes.string,
  actionText : PropTypes.string,
  children   : PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array
  ])
}

/**
 * Represent timeline in the block form. It used to display timeline/process.
 * to implement this component, you need to set timeline class name on the parent div
 * @example
 *  <div
 *     className="timeline timeline-one-side"
 *     data-timeline-axis-style="dashed"
 *    data-timeline-content="axis"
 *   >
 *   {
 *    orders.map((order) => (
 *      <Timeline { ...order }>Content</Timeline>
 *    ))
 *   }
 *  </div>
 * @param {string} time - time at which the thing happen
 * @param {string} title - main title of the timeline block
 * @param {string} color - representing which color should be in the badge
 * @param {string} actionText - representing current action of the timeline block
 * @param {element} children - children component
 */
const TimelineBlock = ({
  time,
  title,
  color,
  actionText,
  children
}) => (
  <div className="timeline-block">
    { /** Timeline icon */ }
    <span className={ `timeline-step badge-${color}` }>
      <i className="ni ni-bell-55" />
    </span>

    { /** Timeline content */ }
    <div className="timeline-content" >
      <Badge
        key={ `${title}-timeline-${actionText}` }
        pill
        color={ color }
        className='badge-lg'
      >
        { StringUtil.humanizeUpperCase(actionText) }
      </Badge>
      <small className="ml-3 text-muted font-weight-bold">
        { TimeUtil.format(time, 'DD MMM YY HH:mm:ss') }
      </small>

      <h4 className="mt-3 mb-0">{ title }</h4>
      <div className="text-sm mt-1 mb-0">
        { children }
      </div>
    </div>

  </div>
)

TimelineBlock.propTypes = propTypes

export default TimelineBlock
